import { Helmet } from 'react-helmet-async';
import { TITLES } from '../../../../types/titles';
import SecurityChangePasswordLayout from '../../../../components/profile/security/change-password';

const ProfileSecurityChangePassword = () => {
	return (
		<>
			<Helmet>
				<title>{TITLES.PROFILE.SECURITY.CHANGE_PASSWORD.INDEX}</title>
			</Helmet>
			<SecurityChangePasswordLayout />
		</>
	);
};

export default ProfileSecurityChangePassword;
